import React from 'react';
import ReactDOM from 'react-dom';

import Parameter from './app/app';

ReactDOM.render(<Parameter />, document.getElementById('root'));
